import { datadogRum } from '@datadog/browser-rum';
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useBrand } from '|/brand';

export type OrderPlacedImplementation = 'opd-mfe' | 'insurance-quote';
type OrderPlacedRouteFamily = 'order-placed' | 'insurance-quote';

const routeFamilyOf = (pathname: string): OrderPlacedRouteFamily =>
  pathname.includes('/order-placed/insurance-quote') ? 'insurance-quote' : 'order-placed';

// Keeps the action name and the facets RUM dashboards already group by. shellModeAllowed: false
// now means Checkout.UI's own insurance quote; `implementation` and `routeFamily` say which page
// served the visit.
export const useOrderPlacedRouteTelemetry = (implementation: OrderPlacedImplementation) => {
  const { brand } = useBrand();
  const routeFamily = routeFamilyOf(useLocation().pathname);
  const hasTracked = useRef(false);

  useEffect(() => {
    if (hasTracked.current) return;
    hasTracked.current = true;
    datadogRum.addAction('opd-shell-mode-resolved', {
      shellModeAllowed: implementation === 'opd-mfe',
      isSlateVehicle: brand === 'slate',
      implementation,
      routeFamily,
      brand
    });
  }, [implementation, routeFamily, brand]);
};
